<script setup lang="ts">
import {FunctionalComponent} from "vue";

/**
 * A single-choice chip group, used for the age band and the sex targeting.
 */
defineProps<{
    modelValue: string;
    options: {value: string, label: string, icon?: FunctionalComponent}[];
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
}>();
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      :aria-pressed="modelValue === option.value"
      class="flex items-center gap-1.5 rounded-full border-[1.5px] border-solid px-3 py-1.5 text-xs font-medium transition-colors"
      :class="modelValue === option.value
        ? 'border-primary bg-primary-lightest text-primary'
        : 'border-gray bg-white hover:border-primary'"
      @click="emit('update:modelValue', option.value)"
    >
      <component
        :is="option.icon"
        v-if="option.icon"
        class="h-3.5 w-3.5"
      />{{ option.label }}
    </button>
  </div>
</template>
